/**
 * Copyright (c) 2019-Present Syncari - All rights reserved.
 */
import * as React from 'react';

import type { PasswordInputProps } from '../../types';
import Icon from '../Icon/Icon';
import TextInput from '../TextInput/TextInput';
import { IconButton } from '../IconButton';

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(({ disabled, ...rest }, ref) => {
  const [visible, setVisible] = React.useState(false);

  return (
    <TextInput
      ref={ref}
      type={visible ? 'text' : 'password'}
      disabled={disabled}
      suffix={
        <IconButton
          icon={visible ? 'actionable/eye-off' : 'actionable/eye-on'}
          aria-label={visible ? 'Hide password' : 'Show password'}
          onClick={() => setVisible((v) => !v)}
          disabled={disabled}
          size={rest.size ?? 'medium'}
          variant="tertiary"
        />
      }
      {...rest}
    />
  );
});

PasswordInput.displayName = 'PasswordInput';

export default PasswordInput;
